import { component } from 'picoapp';
import { show as showOverlay } from '../../js/utils/overlay';

export default component(async (node, ctx) => {
  /**
   * Data + elements
   */
  const itemCountOutput = node.querySelector('.js-itemCount');

  /**
   * Functions
   */
  const updateItemCount = (count) => {
    itemCountOutput.textContent = `(${count})`;
  };

  const handleClick = (event) => {
    event.preventDefault();
    if (document.querySelector('header.header').classList.contains('header--megamenu-open')) {
      document.querySelector('header.header').classList.remove('header--megamenu-open');
    }
    document.querySelectorAll('.header__megamenu').forEach(el => {
      if (el.classList.contains('header__megamenu--active')) {
        el.classList.remove('header__megamenu--active');
      }
    });
  
    showOverlay()
    ctx.emit('cart:toggle');
  };

  const init = () => {
    ctx.on('cart:updated', ({ itemCount }) => updateItemCount(itemCount));
    node.addEventListener('click', handleClick);
  };

  /**
   * Init
   */
  init();
});
